"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.saveI18nSetting = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _selectors = require("./selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var fetchI18nOptions = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getOptions,
  initiatingActionType: _actions.I18nActionTypes.FETCH_I18N_OPTIONS,
  requestStatusSelector: _selectors.getFetchI18nOptionsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchI18nOptions
}));
var fetchI18nSetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSetting,
  initiatingActionType: _actions.I18nActionTypes.FETCH_I18N_SETTING,
  requestStatusSelector: _selectors.getFetchI18nSettingRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchI18nSetting
}));
var saveI18nSetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.set,
  initiatingActionType: _actions.I18nActionTypes.SAVE_I18N_SETTING,
  requestStatusSelector: _selectors.getUpdateI18nSettingRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SaveI18nSetting
}));
exports.saveI18nSetting = saveI18nSetting;

var _default = (0, _reduxObservable.combineEpics)(fetchI18nOptions, fetchI18nSetting);

exports.default = _default;